import pendingAllMethods from './pendingAllMethods.json';
import pendingMBMethods from './pendingMBMethods.json';
import successAllMethods from './successAllMethods.json';
import successMBMethods from './successMBMethods.json';

export const animations = {
	pendingMBMethods,
	successMBMethods,
	pendingAllMethods,
	successAllMethods,
};
